import(/* webpackMode: "eager" */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/(portal)/login/page.tsx");
